import { ListFilter, Search } from 'lucide-react'
import { DataTable } from '../../component/table/dataTable'
import React, { useEffect, useState } from 'react'
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  } from "../../component/ui/dropdown-menu"
  import { Input } from "../../component/ui/input";
import { Button } from '../../component/ui/button';
import DataTable2 from '../../component/table/dataTable2';
import { IoAddOutline } from "react-icons/io5";
import { MdEdit, MdOutlineDelete } from 'react-icons/md';
import AddTicker from '../../component/ticker/addTicker';
import { createTickerForScheme, deleteTickerForScheme, getAllSchemeDetails, getAllSchemesTicker, getSchemeInfo } from '../../utils/util';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSchemeInfo } from '../../context/actions/schemeInfoAction';
import { loaderSet } from '../../context/actions/loaderAction';
import { alertDanger, alertSuccess } from '../../context/actions/toastAction';
import Loader from '../../component/loader';



const Ticker = ({employee}) => {
  
const [currentPage,setCurrentPage]=useState(1)
const [totalPage,setTotalPage]=useState(1)
  const location=useLocation()
  const dispatch=useDispatch()
  const [isLoading,setIsLoading]=useState(false)
    const [addTicker,setAddTicker]=useState(false)
    const navigate=useNavigate()
    const handleAddTicker=()=>{
            setAddTicker(true)
    }


    const HandleDeleteTickerForScheme=async(data)=>{
      setIsLoading(true)
      const payload={
        // scheme_id:"166e507e-b9c2-4ea8-8813-226af5aa40e0",
        // scheme_name:"Vasuki fund 2",
        // scheme_id:data.scheme_id,
        scheme_name:data.scheme_name,
        
      }
      try {
        const response =await deleteTickerForScheme(payload)
        console.log("response for delete Ticker",response)
        if(response)
        {
          if(response?.code===200){

            dispatch(alertSuccess("Ticker Deleted Successfully"))
            handleGetAllTickerDetails()
          }
          setIsLoading(false)
        }
        else{
          dispatch(alertSuccess("Error in Deleting Ticker"))
          setIsLoading(false)
        }
      } catch (error) {
        console.log("Error in Delete ticker",error)
        dispatch(alertDanger("Internal Server Error"))
        setIsLoading(false)
      }
      // finally {
      //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
      // }
    }

    const HandleUpdateTickerStatus = async (data, isChecked) => {
      setIsLoading(true)
      const payload = {
        // scheme_id:data.scheme_id,
        scheme_name:data.scheme_name,
        ticker_message:data.ticker_message,
        ticker_name: data.ticker_name, // Use initial value if input is empty
        isticker: isChecked, // Use the switch state directly
        ticker_id: data.ticker_id
      };
    
      try {
        const response = await createTickerForScheme(payload);
        if (response) {
          console.log("Response for Handle Update status for ticker", response);
          // dispatch(loaderSet(false))
          dispatch(alertSuccess("Ticker Status Updated Successfully"))
          setIsLoading(false)
        }
        else{
          dispatch(alertDanger("Error in Update Status"))
          setIsLoading(false)
        }
      } catch (error) {
        dispatch(alertDanger("Internal Server Error"))
        console.log("Error in HandleUpdateTickerStatus", error);
        setIsLoading(false)
      }
      // finally {
      //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
      // }
    };

    const HandleEditTickerForScheme=async(data)=>{
      setIsLoading(true)
      const payload={
       
        scheme_id:data.scheme_id,
        scheme_name:data.scheme_name,
        scheme_class:data.scheme_class
      }
      try {
        const response= await getSchemeInfo(payload)
        // const response =await deleteTickerForScheme(payload)
        // console.log("response for Edit Ticker",response)

        if(response && response?.code!==200){
          dispatch(alertDanger("Internal Server Error"))
          setIsLoading(false)
          return
        }

        if(response && employee){
          navigate(`/employee/ticker-view?ticker_id=${data?.ticker_id}&ticker_name=${data?.ticker_name}&action_type=${"Edit"}`)
          dispatch(setSchemeInfo(response.data))
          setIsLoading(false)
          return
        }
        if(response){
          navigate(`/admin/ticker-view?ticker_id=${data?.ticker_id}&ticker_name=${data?.ticker_name}&action_type=${"Edit"}`)
          dispatch(setSchemeInfo(response.data))
          setIsLoading(false)
          return
        }
        else{
          dispatch(alertDanger("Error in View Ticker"))
          setIsLoading(false)
        }
        
      } catch (error) {
        dispatch(alertDanger("Internal Server Error"))
        console.log("Error in Edit ticker",error)
        setIsLoading(false)
      }
      // finally {
      //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
      // }
    }

    const [allTickerDetails, setAllTickerDetails] = useState();

    const handleGetAllTickerDetails = async () => {
      setIsLoading(true)
      try {
        const payload ={
          page_no : currentPage,
           per_page : 10
        }
        const response = await getAllSchemesTicker(payload);
        console.log("Response for get ticker details", response);
        
        if (response) {
          const uniqueTickerDetails = response.data.data
            .filter(item => item.ticker_id !== null) // Keep only items with a ticker_id
            .reduce((acc, current) => {
              // Check if the scheme_name is already included
              const isDuplicate = acc.some(item => item.scheme_name === current.scheme_name);
              if (!isDuplicate) {
                acc.push(current); // Add item if it's not a duplicate
              }
              return acc;
            }, []);
    
          setAllTickerDetails(uniqueTickerDetails);
          setTotalPage(response.data.totalPages)
          setIsLoading(false)
        }
        else{
          setIsLoading(false)
        }
      } catch (error) {
        console.log("Error in Ticker Functions", error);
        setIsLoading(false)
      }
    };
    
    useEffect(() => {
      handleGetAllTickerDetails();
    }, []);
    

    const buttonOptions=[
      !employee &&  {
        name:"Delete",
        text: <span className="text-base font-semibold text-sm">Delete</span>,
       
        icon:<MdOutlineDelete size={15} />,
        actionHandleDeleteTickerForScheme:HandleDeleteTickerForScheme,
        },
        {
            name:"Edit",
            text: <span className="text-base font-semibold text-sm">Edit</span>,
           
            icon:<MdEdit size={15} />,
            actionHandleEditTickerForScheme:HandleEditTickerForScheme
            }
      ].filter(Boolean)

      const columns = [
        { id: 'ticker_name', header: 'Ticker Name' },
        { id: 'scheme_name', header: 'Scheme Name' },
        { id: 'created_at', header: 'Created Date' },
        // { id: 'scheme', header: 'Scheme' },
        // { id: 'class', header: 'Class' },
      ];


      const[searchTerm,setSearchTerm]=useState("")
      const searchInputId = "ticker-search";

      const [filteredSchemes,setFilteredSchemes] = useState([])
    
    useEffect(()=>{
    console.log(searchTerm)
    if(searchTerm.length>0){
      setFilteredSchemes(allTickerDetails.filter((scheme) => {
        const search = searchTerm.toLowerCase();
        return (
            scheme.scheme_name.toLowerCase().includes(search) ||
            scheme.ticker_name.toLowerCase().includes(search) 
            
        );
    }))
    }
    else{
      setFilteredSchemes(allTickerDetails)
    }
   
    },[searchTerm,allTickerDetails])

  return (
  <>
  {/* accessiblity fix for silktide issues - H1 heading */}
  <h1 className="sr-only">Ticker</h1>
  {
    !addTicker ?
    (location.pathname==="/admin/ticker-view" || location.pathname==="/employee/ticker-view")
    ?
    <>  <AddTicker forWhichUserType={ employee ? "employee" : "admin"} back={()=>setAddTicker(false)} getAllTickerDetails={ handleGetAllTickerDetails} /></>
    :
    <>

{
        isLoading && <Loader/>
      }
            <div className="w-full flex justify-between items-start p-2 bg-[#FFFFFF] rounded-md">
            <div className="flex w-full justify-end items-center gap-4">

            <div className="flex  gap-2 ">
            <Button variant="outline" size="sm" className="h-10 gap-1 text-sm" onClick={handleAddTicker} >
            <IoAddOutline  className="h-3.5 w-3.5" />
            <span className="sr-only sm:not-sr-only">Add Ticker</span>
                
            </Button>
              </div>

                {/* Search Bar */}
              <div className="flex w-80 gap-2 border-b-2 border-[#0D215C] items-center">
                <label htmlFor={searchInputId} className="sr-only">Search tickers</label>
                <Search className="h-8 w-6 text-muted-foreground pointer-events-none" aria-hidden="true" focusable="false" />
                        <Input
                      id={searchInputId}
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e)=>setSearchTerm(e.target.value)}
                      aria-label="Search tickers"
                            className="rounded-none border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-lg"
                        />
              </div>
          
              {/* Dropdown Menu */}
              {/* <div className="flex items-center gap-2">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" className="h-7 gap-1 text-sm">
                      <ListFilter className="h-3.5 w-3.5" />
                      <span className="sr-only sm:not-sr-only">Filter</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuCheckboxItem checked>Fulfilled</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Declined</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Refunded</DropdownMenuCheckboxItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div> */}
            </div>
          </div>
          
                        
           <div className="w-full bg-[#FFFFFF] mt-4 rounded-md " >  
            <DataTable2 switch={HandleUpdateTickerStatus}
             buttonOptions={buttonOptions}
             totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} 
              // data={filteredSchemes.length>0  ?filteredSchemes :allTickerDetails}
             data={filteredSchemes}
             columns={columns} tableFor='Ticker' /> </div>
          </>
          :
        <>  <AddTicker forWhichUserType={ employee ? "employee" : "admin"} back={()=>setAddTicker(false)} getAllTickerDetails={ handleGetAllTickerDetails} /></>
 	}
  </>
  )
}

export default Ticker
